import React from "react"
import useStyles from "../../styles"
import DefaultButton from "../../../components/DefaultButton"
import { Plus } from "lucide-react"
import { SearchHeader } from "../../../components/SearchHeader"
import useSearchParamStore from "../../../stores/SearchParamStore"
import { Button } from "@material-ui/core"

const FilesLayout = () => {
  const classes = useStyles()
  const { searchParam, setSearchParam, setOpenModal } = useSearchParamStore()

  const handleOpenTagModal = () => {
    setOpenModal(true)
  }

  return (
    <div className={classes.buttonContainer}>
      <Button
        className={classes.buttonNova}
        variant="contained"
        color="primary"
        disableElevation
        startIcon={<Plus />}
        onClick={handleOpenTagModal}
      >
        Nova
      </Button>
      <SearchHeader searchParam={searchParam} setSearchParam={setSearchParam} placeholder={"Pesquisar..."} />
    </div>
  )
}

export default FilesLayout
